import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/sub_districts'

const SubDistrictsApiV2 = {
  /**
   * Get list of `Sub District`
   * @param {object} filters possible value: { province_id: number, province_name: string, city_id: number, city_name: string, district_id: number, district_name: string }
   * @return {object} Collection of `SubDistricts`
   */
  get: async (filters) => {
    const params   = QueryParamsUtil.format(null, filters)
    const response = axios.get(API_PATH, { params })
    return response
  }
}

export default SubDistrictsApiV2
